import { canUseDrawingTool, getDrawingTool } from "./drawingModel";

export function createDrawingPlacementState() {
  return {
    toolId: null,
    points: [],
  };
}

export function beginDrawingPlacement(toolId) {
  if (!canUseDrawingTool(toolId)) return createDrawingPlacementState();
  return {
    toolId,
    points: [],
  };
}

export function cancelDrawingPlacement() {
  return createDrawingPlacementState();
}

export function addDrawingPlacementPoint(state, point) {
  const tool = getDrawingTool(state?.toolId);
  if (!tool || !canUseDrawingTool(tool.id)) {
    return {
      state: createDrawingPlacementState(),
      completedPoints: null,
    };
  }

  if (!point?.timestamp || typeof point.price !== "number" || !Number.isFinite(point.price)) {
    return {
      state,
      completedPoints: null,
    };
  }

  const points = [...state.points, { timestamp: point.timestamp, price: point.price }];
  if (points.length < tool.pointsRequired) {
    return {
      state: { toolId: tool.id, points },
      completedPoints: null,
    };
  }

  return {
    state: { toolId: tool.id, points: [] },
    completedPoints: points.slice(0, tool.pointsRequired),
  };
}
